import { useEffect } from 'react';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { ResetBtn, UseBtn } from 'libs/ui';
import { CategoryFilter, ClassFilter, Container, Input, ParkingFilter, Select, ButtonsContainer, DoubleField, DateSelect, DateTime, DictFilter } from 'libs/form';
import { meanTypes } from './soall.consts';

const initial = {};

const Filter = (props) => {
  const { setInitial, reset, handleSubmit, change, theme } = props;

  const { t } = useTranslation();

  // did mount
  useEffect(() => {
    setInitial(initial);
    return () => {
      reset();
      setInitial(initial);
    };
  }, []);

  const itemsEl = meanTypes.map((el, idx) => (
    <option value={el.value} key={idx}>
      {t('sections.' + el.name)}
    </option>
  ));

  return (
    <Container theme={theme} className="cp-filter">
      <form onSubmit={handleSubmit}>
        <Select width="120px" name="mean_type" type="select" label={t('dict_filter.Тип')} theme={theme}>
          <option value="">{t('filter.Все')}</option>
          {itemsEl}
        </Select>

        <Input width="170px" name="mean_id" type="text" label={t('grid.Номер СО')} placeholder="3786 4678 6467 5656" />

        <Input width="130px" name="vehicle_plate" type="text" label={t('sections.ГРЗ')} placeholder={t('form.А000AA 000 rus')} />

        <DictFilter
          name="is_blocked"
          dict={[/*'payment_mean.status', 'plates.list',*/ 'rfid.status']}
          title="Статус/Список"
          titles={{ Активен: 'Активен/Белый', Заблокирован: 'Заблокирован/Черный' }}
        />

        <DateSelect from_name="start_at_from" to_name="start_at_to" change={change} theme={theme}>
          <DoubleField>
            <DateTime width="160px" name="start_at_from" type="dateTime" label={t('form.Дата действия с')} theme={theme} />
            <DateTime width="160px" name="start_at_to" type="dateTime" theme={theme} />
          </DoubleField>
        </DateSelect>

        <DateSelect from_name="end_at_from" to_name="end_at_to" change={change} theme={theme}>
          <DoubleField>
            <DateTime width="160px" name="end_at_from" type="dateTime" label={t('form.Дата действия по')} theme={theme} />
            <DateTime width="160px" name="end_at_to" type="dateTime" theme={theme} />
          </DoubleField>
        </DateSelect>

        <Input label={t('form.Клиент')} width="230px" name="client_name" type="text" placeholder={t('form.Название клиента')} />

        <ClassFilter multiple />

        <CategoryFilter multiple />

        <Input width={'230px'} name="tariff" type="text" label={t('form.Тариф')} placeholder={t('filter.Базовый')} />

        <Input width="220px" name="owner" type="text" label={t('form.Держатель') + '/' + t('form.Инициатор')} placeholder={t('form.Введите текст для поиска')} />

        <Input label={t('filter.Комментарий') + '/' + t('form.Причина внесения')} width="230px" name="comment" type="text" placeholder={t('filter.Текст комментария')} />

        <ParkingFilter theme={theme} ml0 />

        <ButtonsContainer>
          <ResetBtn onClick={reset} theme={theme} />
          <UseBtn />
        </ButtonsContainer>
      </form>
    </Container>
  );
};

export default reduxForm({
  form: 'soallFilter',
  destroyOnUnmount: false,
  initialValues: initial,
})(Filter);
